import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import initialState from './CalOMSAdmitAuthPdfInitialState';
import { _setAuthPdfPrint } from './CalOMSAdmitAuthPdfAction';
const STOP_REGION = process.env.REACT_APP_STOP_REGION;

export const getCalOMSAdmitPdfForm = createAsyncThunk(
  'stop/getCalOMSAdmitPdfForm',
  async (params) => {
    const { pdfUrl, authorization } = params;

    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION,
      },
    };
    const response = await axios
      .get(pdfUrl, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        return e;
      });

    const data = await response.data;
    return data === undefined ? null : data;
  }
);

const calOMSAdmitPdfSlice = createSlice({
  name: 'stop/calOMSAdmitPdfForm',
  initialState,
  reducers: {
    setAuthPdfPrint: _setAuthPdfPrint,
    resetCalOMSAdmitPdfForm: () => initialState,
  },
  extraReducers: {
    [getCalOMSAdmitPdfForm.fulfilled]: (state, action) => action.payload,
  },
});

export const { setAuthPdfPrint, resetCalOMSAdmitPdfForm } =
  calOMSAdmitPdfSlice.actions;

export default calOMSAdmitPdfSlice.reducer;
